export default "__VITE_ASSET__qMHHG2JdhL5XtnQaGmuqPA__"